import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from 'react';
import { Divider } from '@/app/components/divider';
import { Icon, type IconType } from '@/app/components/icons';
import { IconEco } from '@/app/components/icons/social/icon-eco';
import { IconWeight } from '@/app/components/icons/social/icon-weight';
import { IconEngine } from '@/app/components/icons/transportation/icon-engine';
import { IconSettings } from '@/app/components/icons/ui-actions/icon-settings';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
interface FeatureItemProps {
  index: number;
  detail?: string;
  className?: string;
  style?: CSSProperties;
}
const FEATURE_ROWS: {
  icon: IconType;
  title: string;
}[] = [{
  icon: <IconEngine />,
  title: 'เครื่องยนต์'
}, {
  icon: <IconSettings />,
  title: 'แรงบิดสูงสุด'
}, {
  icon: <IconWeight />,
  title: 'น้ำหนัก'
}, {
  icon: <IconEco />,
  title: 'ระบบบำบัดไอเสีย'
}];
export function FeatureItem(t0) {
  const $ = _c(20);
  const {
    index,
    detail,
    className,
    style
  } = t0;
  const row = FEATURE_ROWS[index];
  const t1 = `item-${index}`;
  let t2;
  if ($[0] !== t1) {
    t2 = createDataAttributes({
      test: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== row) {
    t3 = row !== null && <Icon icon={row.icon} />;
    $[2] = row;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: "item-title"
    });
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = row?.title;
  let t6;
  if ($[5] !== t5) {
    t6 = <p className="text-body-2" {...t4}>{t5}</p>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t3 || $[8] !== t6) {
    t7 = <div className="flex items-center gap-x-2">{t3}{t6}</div>;
    $[7] = t3;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Divider color="gray" size="sm" />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = createDataAttributes({
      test: "item-detail"
    });
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = detail ?? "";
  let t11;
  if ($[12] !== t10) {
    t11 = <strong className="text-body-2" {...t9} dangerouslySetInnerHTML={{
      __html: t10
    }} />;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== className || $[15] !== style || $[16] !== t11 || $[17] !== t2 || $[18] !== t7) {
    t12 = <div {...t2} className={className} style={style}>{t7}{t8}{t11}</div>;
    $[14] = className;
    $[15] = style;
    $[16] = t11;
    $[17] = t2;
    $[18] = t7;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
}